export const JobTitleEN = {
    "jobTitle": {
        "title": {
            "header": "Job title",
            "add": "Create a new job title",
            "update": "Update job title"

        }
    }
}